import React from 'react';
import { TextField, MenuItem, Button } from '@material-ui/core';
import useStyles from './styles';
import { PERIODOS, rotuloPeriodo } from './periodo';

export const FILTROS_INICIAIS = { cliente_id: '', assessor_id: '', periodo: 'mes', de: '', ate: '' };

/**
 * Barra de filtros. Na visão Assessor o filtro de assessor some (o servidor já força o próprio).
 * "Projeto" = Cliente no CRM.
 */
export default function FiltrosHome({ filtros, onChange, clientes, assessores, mostrarAssessor }) {
    const classes = useStyles();
    const set = (campo) => (e) => onChange({ ...filtros, [campo]: e.target.value });
    const alterado = filtros.cliente_id || filtros.assessor_id || filtros.periodo !== 'mes';

    const nomeCliente = (clientes.find((c) => String(c.id) === String(filtros.cliente_id)) || {}).name;
    const nomeAssessor = (assessores.find((a) => String(a.id) === String(filtros.assessor_id)) || {}).name;
    const resumo = [nomeCliente || 'Todos os projetos'];
    if (mostrarAssessor) resumo.push(nomeAssessor || 'Todos os assessores');
    resumo.push(rotuloPeriodo(filtros.periodo, filtros.de, filtros.ate));

    const periodoIncompleto = filtros.periodo === 'personalizado' && !(filtros.de && filtros.ate && filtros.de <= filtros.ate);

    return (
        <section className={classes.filtros} aria-label="Filtros">
            <TextField select variant="outlined" size="small" label="Projeto" className={classes.filtro}
                value={filtros.cliente_id} onChange={set('cliente_id')}
                InputLabelProps={{ shrink: true }} SelectProps={{ displayEmpty: true }}>
                <MenuItem value="">Todos os projetos</MenuItem>
                {clientes.map((c) => <MenuItem key={c.id} value={String(c.id)}>{c.name}</MenuItem>)}
            </TextField>

            {mostrarAssessor && (
                <TextField select variant="outlined" size="small" label="Assessor" className={classes.filtro}
                    value={filtros.assessor_id} onChange={set('assessor_id')}
                    InputLabelProps={{ shrink: true }} SelectProps={{ displayEmpty: true }}>
                    <MenuItem value="">Todos os assessores</MenuItem>
                    {assessores.map((a) => <MenuItem key={a.id} value={String(a.id)}>{a.name}</MenuItem>)}
                </TextField>
            )}

            <TextField select variant="outlined" size="small" label="Período" className={classes.filtro}
                value={filtros.periodo} onChange={set('periodo')}>
                {PERIODOS.map((p) => <MenuItem key={p.valor} value={p.valor}>{p.rotulo}</MenuItem>)}
            </TextField>

            {filtros.periodo === 'personalizado' && (
                <>
                    <TextField type="date" variant="outlined" size="small" label="De" className={classes.filtroData}
                        InputLabelProps={{ shrink: true }} value={filtros.de} onChange={set('de')} />
                    <TextField type="date" variant="outlined" size="small" label="Até" className={classes.filtroData}
                        InputLabelProps={{ shrink: true }} value={filtros.ate} onChange={set('ate')}
                        error={periodoIncompleto && !!filtros.de && !!filtros.ate}
                        helperText={periodoIncompleto && filtros.de && filtros.ate ? 'Deve ser após "De"' : ''} />
                </>
            )}

            <Button variant="outlined" disabled={!alterado} onClick={() => onChange(FILTROS_INICIAIS)}>
                Limpar filtros
            </Button>

            <div className={classes.resumoFiltros}>
                Exibindo: <b style={{ color: '#1B2418' }}>{resumo.join(' · ')}</b>
                {periodoIncompleto && ' — informe as duas datas para atualizar'}
            </div>
        </section>
    );
}
